import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Dropdown,
  Modal,
  Alert,
  Spinner,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
function MoversCategories() {
  var history = useHistory();
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 10;
  const activePag = useRef(0);
  const [name, setName] = useState("");
  const [type, setType] = useState("Go_Movers");
  const [color, setColor] = useState("");
  const [url, setUrl] = useState("");
  const [categories, setAllCategories] = useState("");
  const [updateStatus, setUpdateStatus] = useState(false);
  const [categoryId, setCategoryId] = useState(false);
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [spinner, setSpinner] = useState(true);
  const [test, settest] = useState(0);
  const searchObject=['Go_Movers',"Go_Taxi"]
  function getData() {
    axios
      .get(Baseurl.baseurl + "/go-ui/get-all-movers-categories")
      .then((res) => {
        setSpinner(false);
        setAllCategories(res.data.taxiMoversCategory);
       
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  useEffect(() => {
    getData();
   
  }, []);



  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  

  function addCategory(e) {
    e.preventDefault();
    var items = {
      name: name,
      type: type,
      color: `0XFF${color}`,
      url: url,
    };
    axios
      .post(Baseurl.baseurl + `/go-ui/add-taxi-movers-categories`, items)
      .then((response) => {
        if (response.data.status) {
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          getData();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setShow(false);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function updateCashBack(e) {
    e.preventDefault();
    var items = {
      name: name,
      url: url,
    };
    axios
      .put(Baseurl.baseurl + `/go-ui/update-taxi-movers-categories/${categoryId}`, items)
      .then((response) => {
        if (response.data.status) {
          swal("Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          getData();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setShow(false);
      
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function deleteCategory(){
    axios
      .delete(Baseurl.baseurl + `/go-ui/delete-taxi-movers-categories/${categoryId}`)
      .then((response) => {
        if (response.data.status) {
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });

          getData();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow1(false);
  }
  return (
    <Col lg={12}>
      <Modal
        size="lg"
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Body className="text-center"><h4>Are You Sure !! you want to delete Categories</h4></Modal.Body>
        <Modal.Footer>
            <button onClick={()=>{deleteCategory()}} className="btn btn-danger">Delete</button>
        </Modal.Footer>
      </Modal>
      <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          <form>
          <div className=" mb-3">
                <label>Name</label>
                <input
                  value={name}
                  type="text"
                  className="form-control"
                  placeholder="enter name"
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  required
                />
              </div>
            {!updateStatus && (
             <>
              <div className=" mb-3">
              <label>Type</label>
             
               <select
            className="form- col-sm-12 text-primary p-2"
            id="val-skill"
            name="val-skill"
            placeholder="Select Search Item"
            defaultValue={type}
            onChange={(event) => {
                setType(event.target.value);
            }}
          >
            {searchObject &&
              searchObject.map((val) => <option value={val}>{val}</option>)}
          </select>
            </div>
            <div className=" mb-3">
              <label>Color</label>
              <input
                value={color}
                type="text"
                className="form-control"
                placeholder="enter Color"
                onChange={(e) => {
                  setColor(e.target.value);
                }}
                required
              />
            </div>
             </>
            )}

           
            <div className=" mb-3">
              <label>URL</label>
              <input
                value={url}
                type="text"
                className="form-control"
                placeholder="enter Url"
                onChange={(e) => {
                  setUrl(e.target.value);
                }}
                required
              />
            </div>
            <div className="col-sm-3 mt-3">
              <button
                onClick={(e) => {
                  if (updateStatus) {
                    updateCashBack(e);
                  } else {
                    addCategory(e);
                  }
                }}
                className="btn btn-primary mt-2"
              >
                {updateStatus ? "Update" : "Add"}
              </button>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
    
          </div>
          <button
            onClick={() => {
              setShow(true);
              setColor("");
              setUrl("");
              setUpdateStatus(false);
              setName("")
            }}
            className="btn btn-primary"
          >
            Add Category
          </button>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white text-center" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>SL NO.</strong>
                    </th>
                    <th>
                      <strong>Name</strong>
                    </th>
                    <th>
                      <strong>Type</strong>
                    </th>
                    <th>
                      <strong>Color</strong>
                    </th>
                    <th>
                      <strong>URL</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {categories &&
                    categories.map((cash, key) =>{
                       let  hexString = cash.Color.toString(16);
                        return (
                            <tr key={cash._id}>
                            <td>{key + 1}</td>
                            <td>{cash.CategoryName}</td>
                            <td>{cash.CategoryType}</td>
                            <td style={{display:'flex',justifyContent:'center',alignItems:'flex-end'}} >
                                <div style={{backgroundColor:`#${hexString.slice(2)}`,height:20,width:20}}>

                                </div>
                               
                               
                              </td>
                            <td>{cash.Url}</td>
                            <td>
                              <Dropdown>
                                <Dropdown.Toggle
                                  variant="warning"
                                  className="light sharp i-false"
                                >
                                  {svg1}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={() => {
                                      setShow(true);
                                      setName(cash.CategoryName)
                                      setUrl(cash.Url);
                                      setUpdateStatus(true);
                                      setCategoryId(cash._id);
                                    }}
                                  >
                                    Update
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      setShow1(true);
                                      setCategoryId(cash._id);
                                    }}
                                  >
                                    Delete
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                          </tr>
                        )
                    })}
                </tbody>
              </Table>
            )}

            {!categories && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero CashBack
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default MoversCategories;
